/** Lightweight Expo Router history entry. The Learn layout owns the persistent deck host. */
export function LearnDeckPage() {
  // eslint-disable-next-line han-page-components/no-blank-page -- History-only leaf; LearnLayout renders the persistent, visible LearnDeckHost for this route.
  return null;
}
